import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("Exercise template details controller connected");
  }

  loadDetails(event) {
    const templateId = event.target.value;
    if (!templateId) {
      this.clearDetails();
      return;
    }

    // Use Turbo to fetch and render the details
    fetch(`/exercise_templates/${templateId}/details`, {
      method: "GET",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
        throw new Error("Network response was not ok");
      })
      .then((html) => {
        // Turbo will automatically process the turbo-stream response
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.error("Error loading exercise template details:", error);
        this.clearDetails();
      });
  }

  clearDetails() {
    // Use the same details action but without an ID to clear
    fetch("/exercise_templates/details", {
      method: "GET",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
        throw new Error("Network response was not ok");
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.error("Error clearing exercise template details:", error);
      });
  }
}
